import { render } from "./DropdownContent.vue?vue&type=template&id=588c4a50&scoped=true"
import script from "./DropdownContent.vue?vue&type=script&lang=js"
export * from "./DropdownContent.vue?vue&type=script&lang=js"

import "./DropdownContent.vue?vue&type=style&index=0&id=588c4a50&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-588c4a50"

export default script